(() => {
  // app/scripts/collections-tab.js
  var collectionTabs = class extends HTMLElement {
    constructor() {
      super();
      this.tab_headings = this.querySelectorAll(".tab-links .heading");
      this.tab_items = this.querySelectorAll(".tab__panel-body .tab-item");
      this.tab_headings.forEach((e) => {
        e.addEventListener("click", () => {
          if (e.classList.contains("active")) {
            return;
          }
          this.tab_headings.forEach((ele) => {
            ele.classList.remove("active");
          });
          this.tab_items.forEach((ele2) => {
            ele2.classList.remove("active");
          });
          e.classList.add("active");
          this.tab_items.forEach((ele3) => {
            ele3.classList.remove("active");
            if (ele3.dataset.id == e.dataset.id) {
              ele3.classList.add("active");
            }
          });
        });
      });
    }
  };
  customElements.define("collection-tabs-component", collectionTabs);
})();
